/**
 * Titanoré Labs — Complete Your Kitchen (cart drawer AJAX add)
 * Adds accessory via /cart/add.js, then refreshes cart-drawer section HTML.
 */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function findDrawerHost() {
    return (
      qs('cart-drawer') ||
      qs('#CartDrawer') ||
      qs('[id*="cart-drawer" i]') ||
      qs('.cart-drawer')
    );
  }

  function replaceDrawerHtml(html) {
    if (!html) return false;
    var wrap = document.createElement('div');
    wrap.innerHTML = html.trim();
    var next =
      wrap.querySelector('cart-drawer') ||
      wrap.querySelector('#shopify-section-cart-drawer') ||
      wrap.querySelector('#CartDrawer') ||
      wrap.firstElementChild;
    if (!next) return false;

    var host = findDrawerHost();
    if (!host) return false;

    var section = host.closest('.shopify-section') || host;
    if (next.id && next.id.indexOf('shopify-section') === 0 && section.classList.contains('shopify-section')) {
      section.outerHTML = next.outerHTML;
    } else if (host.tagName && host.tagName.toLowerCase() === 'cart-drawer') {
      host.outerHTML = (wrap.querySelector('cart-drawer') || next).outerHTML;
    } else {
      host.innerHTML = next.innerHTML || next.outerHTML;
    }

    var drawer = findDrawerHost();
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      else {
        drawer.classList.add('active', 'is-open', 'animate');
        document.body.classList.add('overflow-hidden');
      }
    }
    return true;
  }

  function refreshDrawer() {
    var base = window.location.pathname || '/';
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    var url = base + sep + 'sections=' + encodeURIComponent(SECTION_ID);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section_fetch_failed');
        return r.json();
      })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!replaceDrawerHtml(html)) {
          window.location.href = '/cart';
        }
      });
  }

  function addVariant(btn) {
    var id = Number(btn.getAttribute('data-variant-id'));
    if (!id || btn.disabled) return;

    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: [SECTION_ID, 'cart-icon-bubble'],
        sections_url: window.location.pathname || '/'
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION_ID] && typeof window.updateCartDrawer === 'function') {
          var parsed = new DOMParser().parseFromString(data.sections[SECTION_ID], 'text/html');
          var next = parsed.querySelector('#CartDrawer') || parsed.querySelector('cart-drawer');
          var host = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
          if (next && host) {
            updateCartDrawer(host, next);
            if (typeof window.tlLockCartLinePrices === 'function') window.tlLockCartLinePrices(document);
            return;
          }
        }
        if (data && data.sections && data.sections[SECTION_ID]) {
          if (replaceDrawerHtml(data.sections[SECTION_ID])) return;
        }
        return refreshDrawer();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
        window.location.href = '/cart';
      });
  }

  function onClick(e) {
    var btn = e.target.closest('[data-tl-kitchen-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn);
  }

  document.addEventListener('click', onClick);
})();
